import { HeaderContainer } from "../../components/Layout/HeaderContainer/HeaderContainer";
import { PageContainer } from "../../components/Layout/PageContainer/PageContainer";
import { SoonContent } from "../../components/Pages/Soon/Main/SoonContent/SoonContent";
import { AccessHeaderLogo } from "../../components/Shared/Buttons/AccessHeaderLogo";
import { MenuButton } from "../../components/Shared/Buttons/MenuButton";
import { PageTitle } from "../../components/Shared/Headings/PageTitle";

export const SoonPage = () => {
  return (
    <PageContainer
      header={{
        content: (
          <HeaderContainer
            start={<MenuButton />}
            middle={<PageTitle title="Coming Soon" />}
            end={<AccessHeaderLogo />}
          />
        )
      }}
      main={{
        content: <SoonContent />
      }}
    />
  );
};
